import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
import queryString from 'query-string';

import {
  Typography,
  CircularProgress,
  Hidden,
} from '@material-ui/core';

import SearchLayout from '../../dashboard/components/SearchLayout';
import Alert from '../../common/components/Alert';
import SearchResults from '../components/SearchResults';
import SearchLeftPanel from '../components/SearchLeftPanel';
import MobileSearchFilters from '../components/MobileSearchFilters';
import ActionDialog from '../../activities/components/ActionDialog';

import * as searchActions from '../actions';
import { SEARCH_RESULTS } from '../../config/routes';


class Search extends Component {
  state = {
    filtersOpen: false,
    dialogOpen: false,
    confirmVisible: true,
  }

  componentDidMount() {
    document.title = 'Search';
    window.scrollTo(0, 0);
    this.props.searchProfiles(this.props.token, this.props.site.id);
  }

  componentWillReceiveProps(nextProps) {
    window.scrollTo(0, 0);
    if (this.props.location.key !== nextProps.location.key
        && this.props.location.search !== nextProps.location.search) {
      this.props.searchProfiles(this.props.token, this.props.site.id);
    }
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  doSearch = () => {
    const params = this.props.location.search;
    const parsed = queryString.parse(params);
    if (parsed.page) {
      this.props.history.replace(SEARCH_RESULTS);
    } else {
      this.props.searchProfiles(this.props.token, this.props.site.id);
    }
  }

  closeFilters = () => {
    this.setState({
      filtersOpen: false,
    });
  }

  applyFilters = () => {
    this.setState({
      filtersOpen: false,
    });
  }

  openMobileFilters = () => {
    this.setState({
      filtersOpen: true,
    });
  }

  handleRemoveFilter = (activeFilterId, activeFilters) => {
    const updatedFilters = activeFilters.filter(val => val.id !== activeFilterId);
    const parsed = {};
    updatedFilters.forEach((val) => {
      if (!parsed[val.name]) {
        parsed[val.name] = [val.value];
      } else {
        parsed[val.name].push(val.value);
      }
    });
    delete parsed.page;
    window.localStorage.setItem('SELECTED_VALUES', JSON.stringify(parsed));
    this.doSearch();
  }

  paginate = (page) => {
    let data = window.localStorage.getItem('SELECTED_VALUES');
    if (data) {
      data = JSON.parse(data);
      data.page = [page];
      window.localStorage.setItem('SELECTED_VALUES', JSON.stringify(data));
      this.props.history.replace(`${this.props.location.pathname}?page=${page}`);
    }
  }

  saveSearch = () => {
    this.setState({
      dialogOpen: true,
    });
  }

  saveSearchConfirm = () => {
    this.setState({
      confirmVisible: false,
    });
    const params = this.props.location.search;
    this.props.saveSearch(
      this.props.token,
      params,
    );
  }

  closeDialog = () => {
    this.setState({
      dialogOpen: false,
      confirmVisible: true,
    });
  }

  selectSingle = (key, value) => {
    let data = window.localStorage.getItem('SELECTED_VALUES');
    if (data) {
      data = JSON.parse(data);
      data[key] = [value];
      if (key !== 'page') {
        delete data.page;
      }
      window.localStorage.setItem('SELECTED_VALUES', JSON.stringify(data));
      this.doSearch();
    }
  }

  selectMultiple = (key, value) => {
    let data = window.localStorage.getItem('SELECTED_VALUES');
    if (data) {
      data = JSON.parse(data);
      if (!data[key]) {
        data[key] = [value];
      } else if (data[key].includes(value)) {
        data[key] = data[key].filter(val => val !== value);
      } else {
        data[key].push(value);
      }
      delete data.page;
      window.localStorage.setItem('SELECTED_VALUES', JSON.stringify(data));
      this.doSearch();
    }
  }

  render() {
    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let results = null;
    let leftPanel = null;
    let dialog = null;

    if (this.props.searchResults) {
      if (!this.props.loading) {
        results = (
          <SearchResults
            searchResults={this.props.searchResults}
            openMobileFilters={this.openMobileFilters}
            handleRemoveFilter={this.handleRemoveFilter}
            paginate={this.paginate}
            saveSearch={this.saveSearch}
          />
        );
      }
      if (this.props.searchResults.facets) {
        leftPanel = (
          <Hidden smDown>
            <SearchLeftPanel
              facets={this.props.searchResults.facets}
              activeFilters={this.props.searchResults.active_filters}
              selectSingle={this.selectSingle}
              selectMultiple={this.selectMultiple}
              user={this.props.user}
            />
          </Hidden>
        );
        dialog = (
          <Hidden mdUp>
            <MobileSearchFilters
              facets={this.props.searchResults.facets}
              activeFilters={this.props.searchResults.active_filters}
              filtersOpen={this.state.filtersOpen}
              closeFilters={this.closeFilters}
              applyFilters={this.applyFilters}
              selectSingle={this.selectSingle}
              selectMultiple={this.selectMultiple}
              user={this.props.user}
            />
          </Hidden>
        );
      }
    }


    return (
      <SearchLayout
        isAuthenticated
        activeLink="search"
        dashActiveLink="profile"
        user={this.props.user}
        leftPanel={leftPanel}
      >
        {loading}
        {errorAlert}
        {results}
        {dialog}
        <ActionDialog
          open={this.state.dialogOpen}
          close={this.closeDialog}
          actionType="save-search"
          confirm={this.saveSearchConfirm}
          loading={this.props.actionLoading}
          actionError={this.props.actionMessage}
          successMsg={this.props.actionMessage}
          confirmVisible={this.state.confirmVisible}
        />
      </SearchLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    site: state.common.site,
    loading: state.search.loading,
    error: state.search.error,
    searchResults: state.search.searchResults,
    actionLoading: state.search.actionLoading,
    actionMessage: state.search.actionMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(searchActions.onUnmount()),
    searchProfiles: (token, siteID) => dispatch(
      searchActions.searchProfiles(token, siteID),
    ),
    saveSearch: (token, params) => dispatch(searchActions.saveSearch(token, params)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));



// WEBPACK FOOTER //
// ./src/search/containers/Search.js